export default __webpack_public_path__ + "static/media/radar-chart.cd97f703.png";